import React from 'react';
import styled from 'styled-components';
import CommentIcon from 'components/Icon/CommentIcon';

const CommentIconBackground = styled.div`
  position: absolute;
  bottom: 0.25rem;
  left: 0.25rem;
  width: auto;
  height: 1.5rem;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 0.225rem;
  display: flex;
  align-items: center;
`;

const CommentNumberWrapper = styled.div`
  color: white;
  height: 1.4rem;
  font-size: 0.85rem;
  font-weight: 550;
  padding-right: 0.25rem;
`;

const CommentIconWrapper = styled.div`
  padding: 0.1rem 0.2rem 0rem 0.2rem;
`;

interface MediaCommentIconInterface {
  commentCount?: number;
}

const MediaCommentIcon = ({ commentCount }: MediaCommentIconInterface) => {
  return commentCount ? (
    <CommentIconBackground>
      <CommentIconWrapper>
        <CommentIcon />
      </CommentIconWrapper>
      <CommentNumberWrapper>{commentCount}</CommentNumberWrapper>
    </CommentIconBackground>
  ) : (
    <></>
  );
};

export default MediaCommentIcon;
